<script>
    import AppMenuFindItem from "./AppMenuFindItem.svelte";
    import { Button, Input } from "sveltestrap";
    import { scale } from "svelte/transition";
    import l from "./utils/locale";
    import typesData, {
        foodArr,
        furnitureArr,
        electronicsArr,
        vehicleArr,
        sportArr,
        kitchenArr,
        animalArr,
        clothesArr,
    } from "./utils/types";
    import { _log } from "./utils/logger";

    const typesArrays = {
        foodArr,
        furnitureArr,
        electronicsArr,
        vehicleArr,
        sportArr,
        kitchenArr,
        animalArr,
        clothesArr,
    };
    export let options = {};
    let _options = {};
    export let name = "";

    function menuCheckboxTypeHandler(e) {
        const checked = e.target.checked;
        const _name = e.target.name;
        _options[_name] = checked;
        if (checked) {
            options[name].add(_name);
        } else {
            options[name].delete(_name);
        }

        if (!(_name === "face" || _name === "person")) {
            const arr = typesArrays[`${_name}Arr`];

            if (checked) {
                for (const item of arr) {
                    options[name].add(item);
                }
            } else {
                for (const item of arr) {
                    options[name].delete(item);
                }
            }
        }
        _options = _options;
        _log("menuCheckboxTypeHandler", name, options);
    }

    function changeHandler(e) {
        _log("changeHandler", e.detail);
        const checked = e.detail.checked;
        const _name = e.detail.name;
        if (checked) {
            options[name].add(_name);
        } else {
            options[name].delete(_name);
        }
    }

    function has(_name) {
        _log("has(_name)", options[name].has(_name));
        return options[name].has(_name);
    }

    function menuAutocropHandler(e) {
        options.autocrop = !options.autocrop;
        //options = options;
        _log("options.find", options.find);
    }

    function onChangeOptions(e) {
        options.find = e.detail.find;
        _log("onChangeOptions", options.find);
        options = options;
    }
</script>

<div>
    <div class="svgBtn">
        <Button
            color={options.autocrop ? "primary" : "secondary"}
            on:click={menuAutocropHandler}
            ><svg
                xmlns="http://www.w3.org/2000/svg"
                class="ionicon"
                viewBox="0 0 512 512"
                class:activeIcon={options.autocrop}
                ><title>{l["autocrop"]}</title><path
                    d="M458 346H192a26 26 0 01-26-26V54a22 22 0 00-44 0v68H54a22 22 0 000 44h68v154a70.08 70.08 0 0070 70h154v68a22 22 0 0044 0v-68h68a22 22 0 000-44z"
                /><path
                    d="M214 166h106a26 26 0 0126 26v106a22 22 0 0044 0V192a70.08 70.08 0 00-70-70H214a22 22 0 000 44z"
                /></svg
            >
            <div style={`color: ${options.autocrop} ? "white" : "#333"`}>
                {l["autocrop"]}
            </div>
        </Button>
    </div>
    <div class="flex-center" transition:scale={{ duration: 300 }}>
        {#each typesData as item}
            <Input
                checked={has(item)}
                class="checkbox-item-options"
                on:change={menuCheckboxTypeHandler}
                name={item}
                label={l[item]}
                type="checkbox"
                value={false}
            />
        {/each}
    </div>
    <div class="flex-center" transition:scale={{ duration: 300 }}>
        {#if _options.animal}
            <AppMenuFindItem
                {options}
                on:changeFind={onChangeOptions}
                color="green-item"
                arr={animalArr}
                on:change={changeHandler}
            />
        {/if}
        {#if _options.vehicle}
            <AppMenuFindItem
                {options}
                on:changeFind={onChangeOptions}
                color="orange-item"
                arr={vehicleArr}
                on:change={changeHandler}
            />
        {/if}
        {#if _options.food}
            <AppMenuFindItem
                {options}
                on:changeFind={onChangeOptions}
                color="orange-dark-item"
                arr={foodArr}
                on:change={changeHandler}
            />
        {/if}
        {#if _options.furniture}
            <AppMenuFindItem
                {options}
                on:changeFind={onChangeOptions}
                color="darkmagenta-item"
                arr={furnitureArr}
                on:change={changeHandler}
            />
        {/if}
        {#if _options.sport}
            <AppMenuFindItem
                {options}
                on:changeFind={onChangeOptions}
                color="blueviolet-item"
                arr={sportArr}
                on:change={changeHandler}
            />
        {/if}

        {#if _options.electronics}
            <AppMenuFindItem
                {options}
                on:changeFind={onChangeOptions}
                color="crimson-item"
                arr={electronicsArr}
                on:change={changeHandler}
            />
        {/if}
        {#if _options.clothes}
            <AppMenuFindItem
                {options}
                on:changeFind={onChangeOptions}
                color="darkgreen-item"
                arr={clothesArr}
                on:change={changeHandler}
            />
        {/if}
        {#if _options.kitchen}
            <AppMenuFindItem
                {options}
                on:changeFind={onChangeOptions}
                color="cadetblue-item"
                arr={kitchenArr}
                on:change={changeHandler}
            />
        {/if}
    </div>
</div>
